// Configuration du site telecom.mes-demarches-energie.fr : identité, horaires, textes, Google.
// Numéros : config/phoneConfig.js · Opérateurs et URL d'annonces : config/providersData.js
// Textes en français : guillemets doubles uniquement (une apostrophe dans une chaîne entre apostrophes casse le build).
import { PHONES } from "./phoneConfig";
import { PROVIDERS, HOME_ALIASES } from "./providersData";

export const SITE = {
  key: "telecom",
  domain: "https://telecom.mes-demarches-energie.fr",
  brandName: "Mes Démarches Énergie",
  siteLabel: "telecom.mes-demarches-energie.fr",
  themeColor: "#1F3C88",

  phones: PHONES,

  // Mêmes horaires partout (pages, pied de page, FAQ, extensions Google Ads).
  hours: "du lundi au vendredi de 8 h à 21 h et le samedi de 9 h à 18 h",
  hoursShort: "Lun.–ven. 8 h–21 h · sam. 9 h–18 h",

  company: {
    name: "NOMA CREATIVA S.L.",
    form: "société à responsabilité limitée de droit espagnol (sociedad unipersonal), au capital de 3 000 €",
    cif: "B75294942",
    register: "inscrite au Registre du commerce (Registro Mercantil) de Barcelone, feuille B-660273",
    address: "Ronda General Mitre 126, 6e étage, 08021 Barcelone, Espagne",
    phone: "+34 930 52 37 15", // numéro administratif : texte simple, jamais en lien tel:
    email: "contact@mes-demarches-energie.fr",
    privacyEmail: "contact@mes-demarches-energie.fr",
  },
  emailResponse: "sous 72 heures ouvrées",

  vertical: {
    product: "internet et mobile",
    productShort: "internet",
    partner: "un partenaire spécialisé dans la souscription d'offres internet et mobile",
    eyebrow: "Comparateur d'offres internet et mobile",
    homeTitle: "Comparez les offres internet et mobile",
    homeSub:
      "Un conseiller compare par téléphone les offres box et mobile de nos opérateurs partenaires selon vos usages, puis vous aide à souscrire celle que vous choisissez.",
    bullets: [
      "Comparaison gratuite des offres de nos partenaires",
      "Offres box fibre, ADSL et forfaits mobiles",
      "Changement d'opérateur accompagné par un conseiller",
    ],
    savingsTitle: "Réduisez votre abonnement internet",
    savingsText:
      "Une offre box ou mobile plus adaptée à vos usages peut faire baisser votre facture. Le conseiller vous explique les démarches pour changer d'opérateur.",
    seoTitle: "Comparer les offres internet et mobile",
    seoDescription:
      "Mes Démarches Énergie compare par téléphone les offres box et mobile de ses opérateurs partenaires. Service de comparaison gratuit, appel au tarif local.",
  },

  // Pas de renvois d'urgence sur le site télécom.
  emergency: [],

  // Couleurs de l'accueil et des pages sans couleur opérateur.
  defaultTheme: { primary: "#1F3C88", secondary: "#2F80ED" },

  providers: PROVIDERS,
  homeAliases: HOME_ALIASES,

  // Identifiant Google Ads (AW-XXXXXXX) à renseigner si une balise doit être chargée après consentement.
  googleTagId: "",
};
